<template>
    <div class="pagina-ebook">
        <svg
            class="simbolos-svg"
            aria-hidden="true"
        >
            <defs>
                <symbol
                    id="ebook-seta-baixo"
                    viewBox="0 0 24 24"
                >
                    <path d="M12 5v14" />
                    <path d="m19 12-7 7-7-7" />
                </symbol>
                <symbol
                    id="ebook-seta-direita"
                    viewBox="0 0 24 24"
                >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </symbol>
                <symbol
                    id="ebook-divisa-direita"
                    viewBox="0 0 24 24"
                ><path d="m9 18 6-6-6-6" /></symbol>
                <symbol
                    id="ebook-verificar"
                    viewBox="0 0 24 24"
                ><path d="M20 6 9 17l-5-5" /></symbol>
                <symbol
                    id="ebook-livro"
                    viewBox="0 0 24 24"
                >
                    <path d="M12 5v16" />
                    <path
                        d="M20.001 19A2 2 0 0 0 22 17V5a2 2 0 0 0-1.999-2L16 3.002A5 5 0 0 0 12 5a5 5 0 0 0-4-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 1.999 2H8a5 5 0 0 1 4 2 5 5 0 0 1 4-2z"
                    />
                </symbol>
                <symbol
                    id="ebook-circulo-verificar"
                    viewBox="0 0 24 24"
                >
                    <circle
                        cx="12"
                        cy="12"
                        r="10"
                    />
                    <path d="m9 12 2 2 4-4" />
                </symbol>
                <symbol
                    id="ebook-mensagem"
                    viewBox="0 0 24 24"
                >
                    <path
                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
                    />
                </symbol>
                <symbol
                    id="ebook-balanca"
                    viewBox="0 0 24 24"
                >
                    <path d="M12 3v18" />
                    <path d="m19 8 3 8a5 5 0 0 1-6 0zV7" />
                    <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
                    <path d="m5 8 3 8a5 5 0 0 1-6 0zV7" />
                    <path d="M7 21h10" />
                </symbol>
            </defs>
        </svg>

        <header class="cabecalho-site">
            <a
                class="marca"
                href="#inicio"
                aria-label="CESPRO - início"
            >
                <strong>
                    CESPRO
                    <sup>®</sup>
                </strong>
                <span>Inteligência a serviço da gestão pública</span>
            </a>
            <a
                class="acao-cabecalho"
                href="#solicitar"
            >
                Acessar o guia
                <IconeSvg nome="ebook-seta-baixo" />
            </a>
        </header>

        <main>
            <section
                id="inicio"
                class="destaque"
            >
                <div
                    class="ornamento ornamento-um"
                    aria-hidden="true"
                ></div>
                <div
                    class="ornamento ornamento-dois"
                    aria-hidden="true"
                ></div>
                <div class="recipiente grade-destaque">
                    <div class="conteudo-destaque">
                        <span class="rotulo-destaque">
                            <i></i>
                            Guia prático • 1ª edição 2026
                        </span>
                        <h1>Reforma Tributária nos Municípios</h1>
                        <p class="subtitulo-destaque">
                            Como organizar a legislação durante a transição do ISS para o IBS.
                        </p>
                        <p class="citacao-destaque">
                            A transição vai além da troca de siglas: exige clareza sobre o que permanece, o que precisa
                            mudar e quando agir.
                        </p>
                        <div class="acoes-destaque">
                            <a
                                class="botao botao-vermelho"
                                href="#solicitar"
                            >
                                Quero receber o ebook
                                <IconeSvg nome="ebook-seta-direita" />
                            </a>
                            <a
                                class="botao botao-contorno"
                                href="#conteudo"
                            >
                                Conheça o conteúdo
                                <IconeSvg nome="ebook-divisa-direita" />
                            </a>
                        </div>
                    </div>
                    <div class="moldura-capa">
                        <div
                            class="canto-capa"
                            aria-hidden="true"
                        ></div>
                        <img
                            :src="recursos.capa"
                            alt="Capa do Guia Prático Reforma Tributária nos Municípios"
                        />
                    </div>
                </div>
            </section>

            <section

                id="conteudo"

                class="secao"

            >
                <div class="recipiente duas-colunas">
                    <div class="introducao-secao">
                        <span class="rotulo-secao">Por que este guia?</span>
                        <h2>A transição precisa sair do abstrato.</h2>
                        <p>
                            O impacto municipal é concreto: manter a legislação coerente enquanto o ISS perde espaço e o
                            IBS avança. O guia apresenta um caminho organizado para iniciar esse trabalho com segurança.
                        </p>
                        <div class="objetivo">
                            <strong>Objetivo</strong>
                            <p>
                                Transformar um acervo disperso em um plano de adequação legislativa e acompanhamento da
                                transição.
                            </p>
                        </div>
                    </div>
                    <ol class="lista-conteudo">
                        <li
                            v-for="(conteudo, indice) in conteudosGuia"
                            :key="conteudo"
                        >
                            <span>{{ String(indice + 1).padStart(2, '0') }}</span>
                            <strong>{{ conteudo }}</strong>
                            <IconeSvg nome="ebook-verificar" />
                        </li>
                    </ol>
                </div>
            </section>

            <section class="secao metodo">
                <div class="recipiente">
                    <span class="rotulo-secao">Método prático</span>
                    <h2>Cinco passos para organizar a transição.</h2>
                    <p class="descricao-secao">
                        Um roteiro para localizar as normas, compreender os impactos e transformar achados em decisões
                        verificáveis.
                    </p>
                    <div class="etapas">
                        <article
                            v-for="(etapa, indice) in etapas"
                            :key="etapa.titulo"
                        >
                            <div>
                                <small>{{ String(indice + 1).padStart(2, '0') }}</small>
                                <svg
                                    class="icone"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    aria-hidden="true"
                                    v-html="etapa.icone"
                                ></svg>
                            </div>
                            <h3>{{ etapa.titulo }}</h3>
                            <p>{{ etapa.descricao }}</p>
                        </article>
                    </div>
                </div>
            </section>

            <section class="interna">
                <div class="recipiente grade-interna">
                    <div>
                        <span class="rotulo-secao rotulo-secao-claro">Por dentro do material</span>
                        <h2>Informação clara para orientar o próximo passo.</h2>
                        <p>
                            O ebook combina explicações objetivas, exemplos visuais, cronograma e ferramentas de
                            diagnóstico para facilitar a conversa entre Gestão, Fazenda, Procuradoria, Contabilidade,
                            Tecnologia e Legislativo.
                        </p>
                        <blockquote>
                            <IconeSvg nome="ebook-balanca" />
                            <span>
                                Material educativo. A análise e a decisão jurídica permanecem sob responsabilidade dos
                                órgãos competentes do Município.
                            </span>
                        </blockquote>
                    </div>
                    <div
                        class="cartoes-previa"
                        aria-label="Prévias do ebook"
                    >
                        <div>
                            <img
                                :src="recursos.linhaTempo"
                                width="909"
                                height="1287"
                                loading="lazy"
                                alt="Página do ebook: linha do tempo da transição"
                            />
                        </div>
                        <div>
                            <img
                                :src="recursos.passos"
                                width="909"
                                height="1287"
                                loading="lazy"
                                alt="Página do ebook: cinco passos para organizar a transição"
                            />
                        </div>
                        <div>
                            <img
                                :src="recursos.listaVerificacao"
                                width="909"
                                height="1287"
                                loading="lazy"
                                alt="Página do ebook: checklist municipal"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section

                id="solicitar"

                class="secao acesso"

            >
                <div
                    class="linha-superior ciano"
                    aria-hidden="true"
                ></div>
                <div
                    class="linha-superior vermelho"
                    aria-hidden="true"
                ></div>
                <div class="recipiente grade-formulario">
                    <div>
                        <span class="rotulo-secao">Acesso gratuito</span>
                        <h2>Receba o guia e comece a organizar a legislação do seu Município.</h2>
                        <p>
                            Preencha os dados institucionais. Após o envio, o acesso ao ebook será liberado
                            imediatamente.
                        </p>
                        <ul class="beneficios">
                            <li
                                v-for="beneficio in beneficios"
                                :key="beneficio"
                            >
                                <span><IconeSvg nome="ebook-verificar" /></span>
                                {{ beneficio }}

                            </li>
                        </ul>
                    </div>
                    <div class="cartao-formulario">
                        <div
                            v-if="!enviado"
                            ref="conteudoFormulario"
                        >
                            <div class="titulo-formulario">
                                <span><IconeSvg nome="ebook-livro" /></span>
                                <div>
                                    <h3>Solicite seu acesso</h3>
                                    <p>Campos com * são obrigatórios.</p>
                                </div>
                            </div>
                            <form
                                ref="elementoFormulario"
                                @submit.prevent="enviarFormulario"
                            >
                                <input
                                    v-model="formulario.sitio"
                                    class="isca"
                                    type="text"
                                    name="sitio"
                                    tabindex="-1"
                                    autocomplete="off"
                                    aria-hidden="true"
                                />
                                <div class="campo completo">
                                    <label for="ebook-nome">Nome completo *</label>
                                    <input
                                        id="ebook-nome"
                                        v-model.trim="formulario.ds_nome_completo"
                                        name="ds_nome_completo"
                                        type="text"
                                        autocomplete="name"
                                        required
                                    />
                                </div>
                                <div class="campo">
                                    <label for="ebook-municipio">Município *</label>
                                    <input
                                        id="ebook-municipio"
                                        v-model.trim="formulario.ds_municipio"
                                        name="ds_municipio"
                                        type="text"
                                        required
                                    />
                                </div>
                                <div class="campo">
                                    <label for="ebook-uf">UF *</label>
                                    <select
                                        id="ebook-uf"
                                        v-model="formulario.ds_uf"
                                        name="ds_uf"
                                        required
                                    >
                                        <option value="">Selecione</option>
                                        <option
                                            v-for="estado in estados"
                                            :key="estado"
                                            :value="estado"
                                        >
                                            {{ estado }}

                                        </option>
                                    </select>
                                </div>
                                <div class="campo completo">
                                    <label for="ebook-cargo">Cargo ou setor *</label>
                                    <input
                                        id="ebook-cargo"
                                        v-model.trim="formulario.ds_cargo"
                                        name="ds_cargo"
                                        type="text"
                                        placeholder="Ex.: Fazenda, Procuradoria, Contabilidade"
                                        required
                                    />
                                </div>
                                <div class="campo">
                                    <label for="ebook-email">E-mail institucional *</label>
                                    <input
                                        id="ebook-email"
                                        v-model.trim="formulario.ds_email"
                                        name="ds_email"
                                        type="email"
                                        autocomplete="email"
                                        required
                                    />
                                </div>
                                <div class="campo">
                                    <label for="ebook-telefone">WhatsApp</label>
                                    <input
                                        id="ebook-telefone"
                                        v-model.trim="formulario.nr_telefone"
                                        name="nr_telefone"
                                        type="tel"
                                        autocomplete="tel"
                                        placeholder="(00) 00000-0000"
                                    />
                                </div>
                                <label class="consentimento">
                                    <input
                                        v-model="formulario.consentimento"
                                        type="checkbox"
                                        name="consentimento"
                                        required
                                    />
                                    <span>
                                        Autorizo o uso dos dados para o envio do material e para contatos da CESPRO
                                        relacionados à Reforma Tributária. *
                                    </span>
                                </label>
                                <p
                                    v-if="mensagemErro"
                                    class="erro-formulario visivel"
                                    role="alert"
                                >
                                    {{ mensagemErro }}

                                </p>
                                <button
                                    class="botao botao-vermelho botao-envio"
                                    type="submit"
                                    :disabled="carregando"
                                >
                                    <template v-if="carregando">Liberando acesso...</template>
                                    <template v-else>
                                        Receber o ebook
                                        <IconeSvg nome="ebook-seta-direita" />
                                    </template>
                                </button>
                                <p class="aviso-privacidade">
                                    Seus dados serão usados exclusivamente para esta solicitação e contatos
                                    relacionados.
                                </p>
                            </form>
                        </div>
                        <div
                            v-else
                            ref="mensagemSucesso"
                            class="sucesso"
                        >
                            <span class="icone-sucesso"><IconeSvg nome="ebook-circulo-verificar" /></span>
                            <small>Cadastro concluído</small>
                            <h3>Seu guia está disponível.</h3>
                            <p>
                                Clique no botão para abrir o ebook e salvá-lo para consultas durante o planejamento da
                                transição.
                            </p>
                            <a
                                class="botao botao-vermelho botao-download"
                                :href="LINK_PDF"
                                target="_blank"
                                rel="noopener"
                            >
                                <IconeSvg nome="ebook-livro" />
                                Abrir o ebook
                            </a>
                            <button
                                class="botao-redefinir"
                                type="button"
                                @click="redefinirFormulario"
                            >
                                Fazer outro cadastro
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section class="proximo-passo">
                <div class="recipiente grade-proximo">
                    <div>
                        <small>Próximo passo</small>
                        <h2>Precisa organizar a legislação tributária do Município?</h2>
                        <p>
                            A CESPRO apoia as equipes no levantamento, na organização e no acompanhamento das normas
                            durante a transição.
                        </p>
                    </div>
                    <a
                        class="botao botao-escuro"
                        href="https://wa.me/555132738953?text=Ol%C3%A1%2C%20gostaria%20de%20conversar%20sobre%20o%20diagn%C3%B3stico%20legislativo%20da%20Reforma%20Tribut%C3%A1ria."
                        target="nova-janela"
                        rel="noopener"
                    >
                        <IconeSvg nome="ebook-mensagem" />
                        Falar com a CESPRO
                    </a>
                </div>
            </section>
        </main>

        <footer>
            <div class="recipiente grade-rodape">
                <div>
                    <strong class="logo-rodape">
                        CESPRO
                        <sup>®</sup>
                    </strong>
                    <p>
                        Inteligência a serviço da gestão pública. Legislação organizada, acessível e preparada para
                        apoiar decisões mais seguras.
                    </p>
                </div>
                <div class="links-rodape">
                    <a
                        href="https://cespro.com.br"
                        target="nova-janela"
                        rel="noopener"
                    >
                        cespro.com.br
                    </a>
                    <a
                        href="https://wa.me/555132738953"
                        target="nova-janela"
                        rel="noopener"
                    >
                        WhatsApp: (51) 3273-8953
                    </a>
                </div>
            </div>
            <div class="recipiente aviso-legal">
                Este material tem caráter informativo. Normas, cronogramas, atos, leiautes e orientações devem ser
                conferidos nas fontes oficiais vigentes.
            </div>
        </footer>
    </div>
</template>

<script>
import {
    ref,
    reactive,
    onMounted,
    defineComponent,
    onBeforeUnmount,
    nextTick,
    h,
} from 'vue';
import useEbookReformaTributaria from '@/composable/Ebook';
import capa from '@/assets/img/ebook-reforma-tributaria/capa-ebook.jpg';
import linhaTempo from '@/assets/img/ebook-reforma-tributaria/linha-do-tempo.jpg';
import previaPassos from '@/assets/img/ebook-reforma-tributaria/cinco-passos.jpg';
import listaVerificacao from '@/assets/img/ebook-reforma-tributaria/checklist.jpg';

const LINK_PDF = 'https://www.dropbox.com/scl/fi/8ya0sk94wtvdbnthipmtw/CESPRO-Ebook-Reforma-Tributaria.pdf?rlkey=bzo5x8kegb7hqfyf3lahxmgbx&st=aomcf9w3&dl=0';

const criarFormularioInicial = () => ({
    ds_nome_completo: '',
    ds_municipio: '',
    ds_uf: '',
    ds_cargo: '',
    ds_email: '',
    nr_telefone: '',
    consentimento: false,
    sitio: ''
});

const IconeSvg = defineComponent({
    name: 'IconeSvg',
    props: { nome: { type: String, required: true } },
    setup(propriedades) {
        return () =>
            h(
                'svg',
                {
                    class: 'icone',
                    viewBox: '0 0 24 24',
                    fill: 'none',
                    stroke: 'currentColor',
                    'stroke-width': '2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'aria-hidden': 'true',
                    focusable: 'false'
                },
                [h('use', { href: `#${propriedades.nome}` })]
            );
    }

});

export default defineComponent({
    name: 'EbookReformaTributaria',
    components: { IconeSvg },
    setup() {
        const { enviarFormulario: enviarFormularioEbook } = useEbookReformaTributaria();
        const recursos = { capa, linhaTempo, passos: previaPassos, listaVerificacao };
        const elementoFormulario = ref(null);
        const conteudoFormulario = ref(null);
        const mensagemSucesso = ref(null);
        const formulario = reactive(criarFormularioInicial());
        const carregando = ref(false);
        const enviado = ref(false);
        const mensagemErro = ref('');
        const tituloAnterior = ref('');
        const metaDescricao = ref(null);
        const descricaoAnterior = ref(null);
        const estados = [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO'
        ];
        const conteudosGuia = [
            'Linha do tempo da transição do ISS para o IBS',
            'Mapa das normas municipais que merecem atenção',
            'Método prático de organização em cinco passos',
            'Matriz de classificação e planejamento legislativo',
            'Checklist para avaliar a situação do Município'
        ];
        const beneficios = [
            'Download imediato após o cadastro',
            'Conteúdo desenvolvido para equipes municipais',
            'Sem compromisso de contratação'
        ];
        const etapas = [
            {
                titulo: 'Inventariar',
                descricao: 'Localizar normas, dispositivos, vínculos e fontes oficiais.',
                icone:
                    '<path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/><path d="M14 2v5a1 1 0 0 0 1 1h5"/><circle cx="11.5" cy="14.5" r="2.5"/><path d="M13.3 16.3 15 18"/>'
            },
            {
                titulo: 'Relacionar',
                descricao: 'Identificar como cada regra se conecta aos processos municipais.',
                icone:
                    '<path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/>'
            },
            {
                titulo: 'Classificar',
                descricao: 'Separar o que permanece, exige análise ou precisa de transição.',
                icone:
                    '<rect width="8" height="4" x="8" y="2" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/>'
            },
            {
                titulo: 'Planejar',
                descricao: 'Definir responsáveis, marcos de revisão e ações futuras.',
                icone:
                    '<circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/><circle cx="18" cy="5" r="3"/>'
            },
            {
                titulo: 'Monitorar',
                descricao: 'Acompanhar novas normas e manter o plano legislativo atualizado.',
                icone:
                    '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>'
            }

        ];

        const enviarFormulario = async () => {
            mensagemErro.value = '';

            if (!elementoFormulario.value || !elementoFormulario.value.reportValidity() || formulario.sitio) return;
            
            carregando.value = true;
            
            const dados = {
                ...formulario,
                ds_email: formulario.ds_email.toLowerCase(),
            };

            try {
                await enviarFormularioEbook(dados);
                enviado.value = true;
                await nextTick();
                mensagemSucesso.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (erro) {
                mensagemErro.value = erro instanceof Error ? erro.message : 'Ocorreu um erro inesperado.';
            } finally {
                carregando.value = false;
            }

        };

        const redefinirFormulario = async () => {
            Object.assign(formulario, criarFormularioInicial());
            mensagemErro.value = '';
            enviado.value = false;
            await nextTick();
            conteudoFormulario.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
        };

        onMounted(() => {
            tituloAnterior.value = document.title;
            document.title = 'Guia da Reforma Tributária Municipal | CESPRO';
            metaDescricao.value = document.querySelector('meta[name="description"]');
            if (!metaDescricao.value) {
                metaDescricao.value = document.createElement('meta');
                metaDescricao.value.name = 'description';
                document.head.appendChild(metaDescricao.value);
            } else {
                descricaoAnterior.value = metaDescricao.value.content;
            }

            metaDescricao.value.content = 'Baixe o Guia Prático da Reforma Tributária Municipal da CESPRO.';
        });
        
        onBeforeUnmount(() => {
            document.title = tituloAnterior.value;
            if (metaDescricao.value && descricaoAnterior.value !== null)
                metaDescricao.value.content = descricaoAnterior.value;
            else if (metaDescricao.value) metaDescricao.value.remove();
        });

        return {
            recursos,
            beneficios,
            mensagemErro,
            formulario,
            conteudoFormulario,
            conteudosGuia,
            elementoFormulario,
            carregando,
            redefinirFormulario,
            estados,
            etapas,
            enviarFormulario,
            enviado,
            mensagemSucesso,
            LINK_PDF,
        };
    }

});
</script>

<style scoped>
.pagina-ebook {
    min-height: 100vh;
    color: #061a33;
    background: #ffffff;
    font-family: Arial, Helvetica, sans-serif;
}

.pagina-ebook h1,
.pagina-ebook h2,
.pagina-ebook h3 {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
}

.pagina-ebook strong {
    font-weight: 700;
}

* {
    box-sizing: border-box;
}

:global(html) {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    color: #061a33;
    background: #ffffff;
    font-family: Arial, Helvetica, sans-serif;
}

a {
    color: inherit;
    text-decoration: none;
}

img {
    display: block;
    max-width: 100%;
}

button,
input,
select {
    font: inherit;
}

button,
a {
    -webkit-tap-highlight-color: transparent;
}

::selection {
    color: #031b33;
    background: #21d8da;
}

.recipiente {
    width: min(1180px, calc(100% - 40px));
    margin: 0 auto;
}

.cabecalho-site {
    position: absolute;
    z-index: 20;
    top: 0;
    left: 50%;
    width: min(1180px, calc(100% - 40px));
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0;
    color: #fff;
}

.marca {
    display: inline-flex;
    flex-direction: column;
}

.marca strong {
    font-size: 31px;
    line-height: 1;
    letter-spacing: -0.06em;
}

.marca sup,
.logo-rodape sup {
    font-size: 8px;
    margin-left: 2px;
}

.marca span {
    margin-top: 5px;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.72);
}

.acao-cabecalho {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 11px 20px;
    border: 1px solid rgba(33, 216, 218, 0.52);
    border-radius: 999px;
    background: #062441;
    font-size: 14px;
    font-weight: 800;
    transition: 0.2s ease;
}

.acao-cabecalho:hover {
    border-color: #21d8da;
    background: #0a3154;
}

.acao-cabecalho span {
    color: #21d8da;
}

.destaque {
    position: relative;
    min-height: 820px;
    overflow: hidden;
    padding: 174px 0 105px;
    color: white;
    background: #031b33;
}

.destaque::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 67%;
    height: 1px;
    background: rgba(33, 216, 218, 0.4);
}

.ornamento {
    position: absolute;
    transform: rotate(45deg);
    border: 1px solid;
    pointer-events: none;
}

.ornamento-um {
    top: 55px;
    right: -95px;
    width: 320px;
    height: 320px;
    border-color: rgba(33, 216, 218, 0.25);
}

.ornamento-dois {
    top: 80px;
    right: -190px;
    width: 430px;
    height: 430px;
    border-color: rgba(242, 29, 53, 0.32);
}

.grade-destaque {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 1.08fr 0.92fr;
    align-items: center;
    gap: 75px;
}

.rotulo-destaque {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 9px 16px;
    border: 1px solid rgba(33, 216, 218, 0.5);
    border-radius: 999px;
    background: #062441;
    color: #a9f6f4;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.13em;
    text-transform: uppercase;
}

.rotulo-destaque i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #21d8da;
}

h1 {
    max-width: 720px;
    margin: 28px 0 0;
    font-size: clamp(46px, 7vw, 88px);
    line-height: 0.92;
    letter-spacing: -0.055em;
}

.subtitulo-destaque {
    max-width: 660px;
    margin: 28px 0 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: clamp(20px, 2vw, 27px);
    font-weight: 700;
    line-height: 1.55;
}

.citacao-destaque {
    max-width: 580px;
    margin: 28px 0 0;
    padding-left: 20px;
    border-left: 4px solid #21d8da;
    color: rgba(255, 255, 255, 0.69);
    font-size: 18px;
    line-height: 1.7;
}

.acoes-destaque {
    display: flex;
    gap: 12px;
    margin-top: 35px;
}

.botao {
    min-height: 49px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 13px 27px;
    border: 0;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 900;
    transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}

.botao:hover {
    transform: translateY(-2px);
}

.botao-vermelho {
    color: white;
    background: #f21d35;
    box-shadow: 0 14px 35px rgba(242, 29, 53, 0.24);
}

.botao-vermelho:hover {
    background: #d91830;
}

.botao-contorno {
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.23);
    background: transparent;
}

.botao-contorno:hover {
    border-color: rgba(33, 216, 218, 0.7);
    background: rgba(255, 255, 255, 0.05);
}

.moldura-capa {
    position: relative;
    max-width: 475px;
    margin-left: auto;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: #062441;
    box-shadow: 0 32px 70px rgba(0, 0, 0, 0.35);
}

.moldura-capa::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: -20px;
    transform: translate(16px, 20px);
    border: 1px solid rgba(33, 216, 218, 0.3);
}

.canto-capa {
    position: absolute;
    top: -28px;
    right: -28px;
    width: 80px;
    height: 80px;
    border-top: 4px solid #f21d35;
    border-right: 4px solid #f21d35;
}

.moldura-capa img {
    width: 100%;
    aspect-ratio: 1 / 1.414;
    object-fit: cover;
    background: #08233f;
}

.secao {
    padding: 105px 0;
}

.duas-colunas {
    display: grid;
    grid-template-columns: 0.85fr 1.15fr;
    gap: 85px;
    align-items: flex-start;
}

.introducao-secao {
    position: sticky;
    top: 40px;
}

.rotulo-secao {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    color: #0b8795;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.12em;
    text-transform: uppercase;
}

.rotulo-secao::before {
    content: '';
    width: 36px;
    height: 4px;
    background: #16b8b8;
}

h2 {
    margin: 20px 0 0;
    font-size: clamp(37px, 5vw, 55px);
    line-height: 1.06;
    letter-spacing: -0.04em;
}

.introducao-secao > p,
.grade-formulario > div:first-child > p {
    margin: 25px 0 0;
    color: #405169;
    font-size: 18px;
    line-height: 1.75;
}

.objetivo {
    margin-top: 30px;
    padding: 24px;
    border-left: 4px solid #f21d35;
    border-radius: 10px;
    background: #f2f6f9;
}

.objetivo strong {
    color: #0b7083;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.objetivo p {
    margin: 10px 0 0;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.5;
}

.lista-conteudo {
    display: grid;
    gap: 15px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.lista-conteudo li {
    display: grid;
    grid-template-columns: 45px 1fr auto;
    align-items: center;
    gap: 20px;
    padding: 24px;
    border: 1px solid #d7e1e8;
    background: #fff;
    transition: 0.2s ease;
}

.lista-conteudo li:hover {
    transform: translateY(-2px);
    border-color: #20bec0;
    box-shadow: 0 16px 35px rgba(3, 27, 51, 0.08);
}

.lista-conteudo span {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #fff;
    background: #031b33;
    font-size: 14px;
    font-weight: 900;
}

.lista-conteudo strong {
    font-size: 18px;
    line-height: 1.5;
}

.lista-conteudo b {
    color: #16aaa9;
    font-size: 20px;
}

.metodo {
    background: #eef4f7;
}

.descricao-secao {
    max-width: 760px;
    margin: 20px 0 0;
    color: #405169;
    font-size: 18px;
    line-height: 1.7;
}

.etapas {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    margin-top: 48px;
}

.etapas article {
    position: relative;
    min-height: 255px;
    overflow: hidden;
    padding: 24px;
    border: 1px solid #cddae3;
    background: #fff;
    transition: 0.2s ease;
}

.etapas article::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 65px;
    height: 4px;
    background: #f21d35;
}

.etapas article:hover {
    transform: translateY(-3px);
    border-color: #20bec0;
    box-shadow: 0 18px 40px rgba(3, 27, 51, 0.09);
}

.etapas article > div {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    color: #16aaa9;
    font-size: 28px;
}

.etapas small {
    color: #0b8795;
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 0.08em;
}

.etapas h3 {
    margin: 48px 0 0;
    font-size: 20px;
    text-transform: uppercase;
}

.etapas p {
    color: #536377;
    font-size: 14px;
    line-height: 1.65;
}

.interna {
    padding: 105px 0;
    color: white;
    background: #031b33;
}

.grade-interna {
    display: grid;
    grid-template-columns: 1fr 1.05fr;
    align-items: center;
    gap: 70px;
}

.rotulo-secao-claro {
    color: #9cf4f1;
}

.interna p {
    color: rgba(255, 255, 255, 0.69);
    font-size: 18px;
    line-height: 1.75;
}

.interna blockquote {
    margin: 30px 0 0;
    padding-left: 20px;
    border-left: 4px solid #21d8da;
    color: rgba(255, 255, 255, 0.82);
    line-height: 1.65;
}

.cartoes-previa {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    align-items: flex-start;
}

.cartoes-previa > div {
    min-width: 0;
    padding: 6px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: white;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.23);
}

.cartoes-previa > div:nth-child(2) {
    transform: translateY(32px);
}

.cartoes-previa img {
    width: 100%;
    height: auto;
}

.acesso {
    position: relative;
}

.linha-superior {
    position: absolute;
    top: 0;
    height: 8px;
}

.linha-superior.ciano {
    left: 0;
    width: 34%;
    background: #21babc;
}

.linha-superior.vermelho {
    right: 0;
    width: 100px;
    background: #f21d35;
}

.grade-formulario {
    display: grid;
    grid-template-columns: 0.82fr 1.18fr;
    gap: 70px;
    align-items: flex-start;
}

.beneficios {
    display: grid;
    gap: 17px;
    margin: 30px 0 0;
    padding: 0;
    list-style: none;
    font-weight: 700;
}

.beneficios li {
    display: flex;
    align-items: center;
    gap: 12px;
}

.beneficios span {
    width: 25px;
    height: 25px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #0d8f91;
    background: #dff8f7;
}

.cartao-formulario {
    min-height: 560px;
    padding: 35px;
    border: 1px solid #d3dfe6;
    background: white;
    box-shadow: 0 24px 65px rgba(3, 27, 51, 0.12);
}

.titulo-formulario {
    display: flex;
    align-items: center;
    gap: 15px;
    padding-bottom: 22px;
    border-bottom: 1px solid #dbe4e9;
}

.titulo-formulario > span {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #21d8da;
    background: #031b33;
    font-size: 22px;
}

.titulo-formulario h3 {
    margin: 0;
    font-size: 21px;
}

.titulo-formulario p {
    margin: 5px 0 0;
    color: #607083;
    font-size: 14px;
}

form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 27px;
}

.campo {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.campo.completo,
.consentimento,
.erro-formulario,
.botao-envio,
.aviso-privacidade {
    grid-column: 1 / -1;
}

.campo label {
    font-size: 14px;
    font-weight: 800;
}

.campo input,
.campo select {
    width: 100%;
    height: 48px;
    padding: 0 13px;
    border: 1px solid #cbd8e1;
    border-radius: 6px;
    color: #061a33;
    background: #fff;
    outline: none;
}

.campo input:focus,
.campo select:focus {
    border-color: #17bfc0;
    box-shadow: 0 0 0 3px rgba(23, 191, 192, 0.18);
}

.consentimento {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    color: #536377;
    font-size: 14px;
    line-height: 1.55;
    cursor: pointer;
}

.consentimento input {
    width: 17px;
    height: 17px;
    margin-top: 2px;
    accent-color: #0b8795;
}

.isca {
    position: absolute !important;
    left: -9999px !important;
}

.botao-envio {
    width: 100%;
    font-size: 16px;
}

.botao-envio[disabled] {
    cursor: wait;
    opacity: 0.72;
}

.aviso-privacidade {
    margin: -5px 0 0;
    color: #758394;
    font-size: 12px;
    text-align: center;
}

.erro-formulario {
    display: none;
    margin: 0;
    padding: 12px 15px;
    border-left: 4px solid #f21d35;
    color: #9f1239;
    background: #fff1f2;
    font-size: 14px;
    font-weight: 700;
}

.erro-formulario.visivel {
    display: block;
}

.sucesso {
    min-height: 490px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.sucesso[hidden] {
    display: none;
}

.icone-sucesso {
    width: 55px;
    height: 55px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: white;
    background: #13a7a7;
    font-size: 28px;
}

.sucesso small {
    margin-top: 26px;
    color: #0b8795;
    font-weight: 900;
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.sucesso h3 {
    margin: 12px 0 0;
    font-size: 34px;
}

.sucesso p {
    color: #405169;
    line-height: 1.65;
}

.botao-download {
    width: 100%;
    margin-top: 18px;
}

.botao-redefinir {
    margin-top: 18px;
    border: 0;
    color: #0b7083;
    background: transparent;
    font-weight: 800;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 4px;
}

.proximo-passo {
    padding: 65px 0;
    background: #eef4f7;
}

.grade-proximo {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 50px;
}

.proximo-passo small {
    color: #0b8795;
    font-weight: 900;
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.proximo-passo h2 {
    margin-top: 12px;
    font-size: clamp(30px, 4vw, 42px);
}

.proximo-passo p {
    max-width: 790px;
    color: #405169;
    font-size: 18px;
    line-height: 1.65;
}

.botao-escuro {
    color: white;
    background: #031b33;
}

.botao-escuro:hover {
    background: #0a3154;
}

footer {
    padding: 48px 0 25px;
    color: white;
    background: #031427;
}

.grade-rodape {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 40px;
}

.logo-rodape {
    font-size: 32px;
    letter-spacing: -0.055em;
}

.grade-rodape p {
    max-width: 550px;
    color: rgba(255, 255, 255, 0.58);
    font-size: 14px;
    line-height: 1.65;
}

.links-rodape {
    display: grid;
    align-content: start;
    gap: 10px;
    text-align: right;
}

.links-rodape a:first-child {
    font-weight: 900;
}

.links-rodape a:last-child {
    color: rgba(255, 255, 255, 0.67);
}

.aviso-legal {
    margin-top: 30px;
    padding-top: 22px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.45);
    font-size: 12px;
    line-height: 1.6;
}

@media (max-width: 1050px) {
    .grade-destaque,
    .duas-colunas,
    .grade-interna,
    .grade-formulario {
        grid-template-columns: 1fr;
    }

    .destaque {
        padding-bottom: 80px;
    }

    .moldura-capa {
        max-width: 500px;
        margin: 25px auto 0;
    }

    .introducao-secao {
        position: static;
    }

    .etapas {
        grid-template-columns: repeat(3, 1fr);
    }

    .grade-formulario {
        gap: 45px;
    }

}
@media (max-width: 720px) {
    .recipiente,
    .cabecalho-site {
        width: min(100% - 30px, 1180px);
    }

    .cabecalho-site {
        padding-top: 20px;
    }

    .acao-cabecalho {
        display: none;
    }

    .destaque {
        min-height: auto;
        padding: 130px 0 75px;
    }

    .acoes-destaque {
        flex-direction: column;
    }

    .botao {
        width: 100%;
    }

    .moldura-capa {
        width: calc(100% - 20px);
    }

    .secao,
    .interna {
        padding: 75px 0;
    }

    .etapas {
        grid-template-columns: 1fr;
    }

    .etapas article {
        min-height: 210px;
    }

    .etapas h3 {
        margin-top: 34px;
    }

    .cartoes-previa {
        gap: 7px;
    }

    .cartoes-previa > div {
        padding: 6px;
    }

    .cartao-formulario {
        padding: 25px 20px;
    }

    form {
        grid-template-columns: 1fr;
    }

    .campo {
        grid-column: 1 / -1;
    }

    .grade-proximo,
    .grade-rodape {
        grid-template-columns: 1fr;
    }

    .links-rodape {
        text-align: left;
    }

}
@media (prefers-reduced-motion: reduce) {
    html {
        scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
        scroll-behavior: auto !important;
        transition: none !important;
    }

}

/* Proporções, ícones e pontos de quebra equivalentes à versão Site. */
.icone {
    display: inline-block;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    vertical-align: middle;
}

.acao-cabecalho .icone {
    width: 16px;
    height: 16px;
    color: #21d8da;
}

.botao-contorno .icone,
.botao-escuro .icone {
    color: #21d8da;
}

.lista-conteudo > li > .icone {
    color: #16aaa9;
}

.etapas article > div > .icone {
    width: 28px;
    height: 28px;
    color: #16aaa9;
}

.beneficios .icone {
    width: 16px;
    height: 16px;
}

.icone-sucesso .icone {
    width: 28px;
    height: 28px;
}

.interna blockquote {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.interna blockquote .icone {
    width: 24px;
    height: 24px;
    margin-top: 4px;
    color: #21d8da;
}

.recipiente,
.cabecalho-site {
    width: 100%;
    max-width: 1280px;
    padding-left: 48px;
    padding-right: 48px;
}

.grade-destaque {
    gap: 56px;
}

.moldura-capa {
    width: 100%;
    max-width: 500px;
}

.duas-colunas {
    gap: 56px;
}

.grade-interna,
.grade-formulario {
    gap: 48px;
}

.secao,
.interna {
    padding-top: 112px;
    padding-bottom: 112px;
}

h2 {
    font-size: 48px;
    line-height: 1.25;
    letter-spacing: -0.035em;
}

.metodo h2,
.descricao-secao {
    max-width: 768px;
}

h1 {
    font-size: clamp(44px, 7vw, 92.8px);
    line-height: 0.91;
}

.subtitulo-destaque {
    font-size: 24px;
}

.acoes-destaque {
    flex-wrap: wrap;
}

.etapas {
    gap: 16px;
}

.etapas h3 {
    margin-top: 48px;
    letter-spacing: -0.02em;
}

.cartoes-previa {
    gap: 20px;
}

.proximo-passo h2 {
    font-size: 36px;
    line-height: 1.12;
}

.grade-rodape {
    padding-top: 0;
    padding-bottom: 0;
}

:focus-visible {
    outline: 3px solid #0b8795;
    outline-offset: 4px;
}

[hidden] {
    display: none !important;
}

.simbolos-svg {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
}

@media (min-width: 1024px) {
    .grade-destaque {
        grid-template-columns: 1.08fr 0.92fr;
    }

    .duas-colunas {
        grid-template-columns: 0.85fr 1.15fr;
    }

    .grade-interna {
        grid-template-columns: 1fr 1.05fr;
    }

    .grade-formulario {
        grid-template-columns: 0.82fr 1.18fr;
    }

    .moldura-capa {
        margin: 0 0 0 auto;
    }

    .introducao-secao {
        position: sticky;
        top: 48px;
    }

}
@media (min-width: 768px) and (max-width: 1279px) {
    .etapas {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

}
@media (max-width: 1023px) {
    .recipiente,
    .cabecalho-site {
        padding-left: 32px;
        padding-right: 32px;
    }

    .grade-destaque,
    .duas-colunas,
    .grade-interna,
    .grade-formulario {
        grid-template-columns: 1fr;
    }

    .moldura-capa {
        margin: 0 auto;
    }

    .destaque {
        padding-top: 144px;
        padding-bottom: 80px;
    }

    .introducao-secao {
        position: static;
    }

    .grade-proximo {
        grid-template-columns: 1fr;
        gap: 32px;
    }

    .grade-proximo .botao {
        justify-self: start;
    }

}
@media (max-width: 767px) {
    .etapas {
        grid-template-columns: 1fr;
    }

}
@media (max-width: 639px) {
    .recipiente,
    .cabecalho-site {
        padding-left: 20px;
        padding-right: 20px;
    }

    .secao,
    .interna {
        padding-top: 80px;
        padding-bottom: 80px;
    }

    h2 {
        font-size: 36px;
    }

    .subtitulo-destaque {
        font-size: 20px;
    }

    .citacao-destaque {
        font-size: 16px;
    }

    .lista-conteudo li {
        padding: 20px;
        gap: 20px;
    }

    .lista-conteudo strong {
        font-size: 16px;
    }

    .cartoes-previa {
        gap: 12px;
    }

    .proximo-passo h2 {
        font-size: 30px;
    }

}
</style>
